import { useTranslation } from 'react-i18next';
import { Badge, TableCell } from '../../../../2-component';
import { formatMoneyValueCentsWithDecimals, formatDecimalNumber } from '../../../../../util';
import { useLocalization } from '../../../../../util/useLocalization';
import { CustodianActivity, CustodianActivityStates } from '../../../../../interfaces';

export const CustodianActivityCell = ({
  custodianActivity, type, isFirst,
}: { custodianActivity: CustodianActivity, type: string, isFirst?: boolean }) => {
  const { t } = useTranslation(['components', 'shared', 'accountTypes']);
  const { localizedDate } = useLocalization();

  const stateColor = custodianActivity.state === CustodianActivityStates.RECONCILED ? 'positive' : 'neutral';

  switch (type) {
    case 'accountType':
      return <TableCell isFirst={isFirst} dense> {t(`accountTypes:${custodianActivity.account?.type}`)}</TableCell>;
    case 'accountNumber':
      return <TableCell isFirst={isFirst} dense>{custodianActivity.account?.custodianAccountNumber}</TableCell>;
    case 'security':
      return <TableCell isFirst={isFirst} dense bold>{custodianActivity.financialProduct?.ticker ?? custodianActivity.symbol ?? '-'}</TableCell>;
    case 'transactionType':
      return <TableCell isFirst={isFirst} dense>{t(`transaction.types.${custodianActivity.transactionType}`)}</TableCell>;
    case 'currency':
      return <TableCell isFirst={isFirst} dense>{custodianActivity.currency ?? '-'}</TableCell>;
    case 'transactionDesc':
      return <TableCell isFirst={isFirst} dense>{custodianActivity.transactionDesc ?? '-'}</TableCell>;
    case 'amount':
      return <TableCell isFirst={isFirst} dense>{formatMoneyValueCentsWithDecimals(custodianActivity.amountValueCents)}</TableCell>;
    case 'quantity':
      return <TableCell isFirst={isFirst} dense number>{custodianActivity.quantity ? formatDecimalNumber(custodianActivity.quantity) : '-'}</TableCell>;
    case 'price':
      return <TableCell isFirst={isFirst} dense number>{custodianActivity.priceCents ? formatMoneyValueCentsWithDecimals(custodianActivity.priceCents) : '-'}</TableCell>;
    case 'state':
      return <TableCell isFirst={isFirst} dense><Badge label={t(`reconciliation:activityState.${custodianActivity.state}`)} color={stateColor} /></TableCell>;
    case 'processDate':
      return <TableCell isFirst={isFirst} dense >{localizedDate(custodianActivity.processDate)}</TableCell>;
    case 'effectiveDate':
      return <TableCell isFirst={isFirst} dense >{localizedDate(custodianActivity.effectiveDate)}</TableCell>;
    default:
      return <TableCell isFirst={isFirst}>{type}</TableCell>;
  }
};
